export enum ClearWorkspaceActionType {
  CLOSE_SELF = 'CLOSE_SELF',
  CLOSE_ALL = 'CLOSE_ALL',
  CLOSE_OTHERS = 'CLOSE_OTHERS',
  CLOSE_RIGHT = 'CLOSE_RIGHT',
}
